import { SuccessRO } from '@routellers/types/dist/shared/success.ro';

import { ApiMethodDeclaration } from '..';

type ParamsData = undefined;

type ResponseData = SuccessRO & {
    ok?: number;
    unchanged?: number;
    missing?: number;
    failed?: number;
    durationMs?: number;
};

export const syncFromCdn: ApiMethodDeclaration<ParamsData, ResponseData> = () => ({
    url: '/translations/sync-from-cdn',
    method: 'GET',
});
